<template>
	<button
		class="itinerary-menu-item d-flex align-center gap-2 text-align-left pa-2 rounded-1 cursor-pointer relative"
		:class="[isActive ? 'bg-neutral-100' : 'bg-transparent', isCollapsed ? 'justify-center' : '']"
		:title="isCollapsed ? name : undefined"
		@click="$emit('click')"
	>
		<NewIcon
			:icon="icon"
			:type="isActive ? 'fill' : 'light'"
			radius="16px"
			:title="isCollapsed ? name : undefined"
		/>

		<div
			v-if="isCollapsed && isNew"
			class="absolute right-0 top-0 bg-primary-600 rounded-circle"
			style="width: 6px; height: 6px; top: 12%; right: 15%"
		></div>

		<div v-if="!isCollapsed" class="d-flex width-full justify-space-between align-center">
			<p class="text-body-m text-start">
				{{ name }}
			</p>
			<span v-if="isNew" class="text-label-s new-badge">
				{{ $t('common.new') }}
			</span>
			<Icon v-else-if="showCheck && isActive" icon="check-simple" />
		</div>
	</button>
</template>

<script setup lang="ts">
	interface Props {
		name: string
		icon: string
		isActive?: boolean
		isCollapsed?: boolean
		showCheck?: boolean
		isNew?: boolean
	}

	withDefaults(defineProps<Props>(), {
		icon: 'file',
		activeIcon: '',
	})
	defineEmits(['click'])
</script>

<style scoped lang="scss">
	.itinerary-menu-item {
		height: 38px;
		&:hover {
			background-color: var(--color-neutral-100);
		}
	}
	.new-badge {
		background-color: var(--color-positive-25);
		color: var(--color-positive-600);
		border-radius: 4px;
		padding: 1px 6px;
	}
</style>
